// extracted by mini-css-extract-plugin
export var box = "_3h-0";
export var check = "_3h-1";
export var checkboxButton = "_3h-6";
export var checkboxGroup = "_3h-5";
export var disabled = "_3h-7";
export var ghost = "_3h-9";
export var input = "_3h-2";
export var label = "_3h-4";
export var normal = "_3h-8";
export var uncheck = "_3h-3";